export default {
    FUNCTION: 638,
    TARIFF: 639,
    VALUE: 642,
    QUANTITY: 641,
    TOTAL: 640
};